const NationalinsightsType = {
	SET_SELECTED_STATE_COUNT: "SET_SELECTED_STATE_COUNT",
	SET_COMPARE_TOGGLE: "SET_COMPARE_TOGGLE",
	SET_INTRO_MODEL: "SET_INTRO_MODEL",
};

export default NationalinsightsType;
